import { PropsWithChildren } from 'react';
import { Box, Flex, Heading } from '@chakra-ui/react';

interface Props extends PropsWithChildren {
  title: string;
}

export const SearchResult = (props: Props) => {
  const { title, children } = props;

  return (
    <Box w="full">
      <Flex w="full" align="flex-start">
        <Heading fontSize="1.5rem">{title}</Heading>
      </Flex>

      {children}
    </Box>
  );
};
